(function () {
    'use strict';

    angular
        .module('app')
        .controller('AdminController', AdminController);

    AdminController.$inject = ['$http', '$rootScope', '$stateParams', '$state', '$filter', '$scope', 'dateParser', 'dialog', 'cache'];

    function AdminController($http, $rootScope, $stateParams, $state, $filter, $scope, dateParser, dialog, cache) {
        $rootScope.dark_text_header = true;
        $rootScope.hide_header = true;
        $rootScope.hide_footer = true;
        var vm = this;
        vm.$onInit = init;
        vm.close = close;
        vm.isPage = isPage;
        vm.isPane = isPane;
        vm.isSubPane = isSubPane;
        vm.isCountryFilter = isCountryFilter;
        vm.showDropdown = showDropdown;
        vm.copyEmail = copyEmail;
        vm.updateFilter = updateFilter;
        vm.goToProfile = goToProfile;
        vm.selectSortingOrder = selectSortingOrder;
        vm.closeFilters = closeFilters;
        vm.getMusicians = getMusicians;
        vm.countVoucherConcerts = countVoucherConcerts;
        vm.showVoucherConcerts = showVoucherConcerts;
        vm.hideVoucherConcerts = hideVoucherConcerts;
        vm.createVoucher = createVoucher;
        vm.updateVoucher = updateVoucher;
        vm.archiveVoucher = archiveVoucher;
        vm.showDraft = 0;
        vm.dropdownToggle = Array();
        vm.resultsPerPage = 48;
        vm.pageNum = 1;
        vm.offset = 0;

        vm.freetext = "";

        vm.sortBy = "date_added";
        vm.selected_genres = [];

        vm.spaceTypes = [
            { spaceType: "Private home", spaceTypeSlug: "private_home" },
            { spaceType: "Outdoor", spaceTypeSlug: "outdoors" },
            { spaceType: "Workspace", spaceTypeSlug: "workspace" },
            { spaceType: "Other", spaceTypeSlug: "other" },
        ];
        vm.statuses = [
            { status: "Superhost", statusSlug: "superhost" }
        ];
        vm.seatRanges = [
            { seatRange: "10-20", range: { from: 1, to: 20 } }, // We don't wan't people to know that there are spaces with less than ten seats, so we show it as '10-20 seats'
            { seatRange: "20-40", range: { from: 20, to: 40 } },
            { seatRange: "40+", range: { from: 40, to: 9999 } } // What IS the maximum number of seats we want to show?
        ];
        vm.sortingOrders = [
            { sortingOrder: 'Newest to oldest', sortingOrderSlug: 'newest_to_oldest', selected: true },
            { sortingOrder: 'Relevance', sortingOrderSlug: 'relevance' },
            { sortingOrder: 'Name', sortingOrderSlug: 'name' },
            { sortingOrder: 'Most concerts', sortingOrderSlug: 'most_concerts' }
        ];
        vm.feeAmounts = [
            { name: "0%", value: 0 },
            { name: "5%", value: 5 },
            { name: "7%", value: 7 },
            { name: "10%", value: 10 },
            { name: "12%", value: 12 },
        ];
        vm.showOffClickOverlay = function () {
            var r = false;
            Object.keys(vm.dropdownToggle).forEach(function (key) {
                if (vm.dropdownToggle[key] != null) {
                    r = true;
                }
            });
            return r;
        }

        function isPage(page) { return vm.page == page; }
        function isPane(pane) { return vm.pane == pane; }
        function isSubPane(subPane) { return vm.subPane == subPane; }
        function isCountryFilter(countryFilter) { return vm.countryFilter == countryFilter; }
        function showDropdown(name, id, event) {
            if (vm.dropdownToggle[name] != id) {
                vm.dropdownToggle[name] = id;
            } else {
                vm.dropdownToggle[name] = null;
            }
            Object.keys(vm.dropdownToggle).forEach(function (key) {
                if (key != name) {
                    vm.dropdownToggle[key] = null;
                }
            });
            event.stopPropagation();
        }
        function copyEmail(email) {
            if (!navigator.clipboard) {
                fallbackCopyTextToClipboard(email);
                return;
            }
            navigator.clipboard.writeText(email);
        }
        function updateFilter() {
            if (vm.isPane('profiles')) {
                if (vm.isPage('artists')) {
                    getMusicians();
                } else if (vm.isPage('hosts')) {
                    getHosts();
                }
            } else {
                if (vm.isPage('artists')) {
                    setFilteredArtists();
                } else if (vm.isPage('hosts')) {
                    setFilteredHosts();
                }
            }

        }

        function init() {
            vm.message = false;
            vm.page = $stateParams.page ? $stateParams.page : 'hosts';
            vm.pane = $stateParams.pane ? $stateParams.pane : 'profiles';
            vm.subPane = $stateParams.subPane ? $stateParams.subPane : 'submissions';
            vm.countryFilter = $stateParams.countryFilter ? $stateParams.countryFilter : 'all';
            vm.voucherFilter = $stateParams.voucherFilter ? $stateParams.voucherFilter : 'active';
            vm.datePlaceholder = 'DD.MM.YYYY'
            vm.uiDateOptions = angular.copy($rootScope.uiDateConfig);
            vm.uiDateOptions.minDate = new Date();

            var deregister_toggle_message = $scope.$on('toggle_message', function () {
                vm.message = false;
            });

            $scope.$on('$destroy', function () {
                $rootScope.hide_header = false;
                deregister_toggle_message();
            });

            getUser().then(function (response) {
                if (!response.is_admin) {
                    $state.go('frontpage');
                } else {
                    vm.getGenres();
                    if (vm.page == 'hosts') {
                        getUnPublishedHosts();
                    } else if (vm.page == 'artists') {
                        getUnPublishedBands();
                    } else if (vm.page == 'vouchers') {
                        getVouchers();
                    }
                    getEmailTypes();
                    vm.notifications = $rootScope.notifications;
                    vm.user_avatar = $rootScope.user_avatar;
                }
            });
        }

        vm.getSelectedSpaceTypes = function () {
            var selectedSpaceTypes = [];
            vm.spaceTypes.forEach(spaceType => {
                if (spaceType.selected) selectedSpaceTypes.push(spaceType);
            });
            return selectedSpaceTypes;
        }

        vm.getSelectedGenres = function () {
            if (!vm.genres) return;
            var selectedGenres = [];
            vm.genres.forEach(function (genre) {
                if (genre.selected) {
                    selectedGenres.push(genre)
                }
            });
            return selectedGenres;
        }

        vm.selectGenre = function (genre) {
            genre.selected = !genre.selected;
            vm.search();
        }

        vm.search = function () {
            if (vm.page == 'hosts') {
                getHosts();
            } else if (vm.page == 'artists') {
                getMusicians();
            }
        }

        vm.getGenres = function () {
            if (cache.exists('genres')) {
                vm.genres = cache.load('genres');
                return Promise.resolve();
            } else {
                return $http.get('api/genres/')
                    .then(function (response) {
                        vm.genres = response.data;
                        cache.save('genres', vm.genres);
                    });
            }
        }

        vm.updatePage = function (page) {
            if (page > 0 && page <= Math.ceil(parseInt(vm.allResultsCount) / vm.resultsPerPage)) {
                vm.pageNum = page;
                if (vm.page == 'hosts') {
                    getHosts();
                } else if (vm.page == 'artists') {
                    getMusicians();
                }
            }
        }

        function selectSortingOrder(sortingOrder) {
            vm.sortingOrders.forEach(function (sortingOrder) {
                sortingOrder.selected = false;
            });
            sortingOrder.selected = !sortingOrder.selected;
            getHosts();
        }

        function getSelectedSortingOrders() {
            var selectedSortingOrders = [];
            vm.sortingOrders.forEach(sortingOrder => {
                if (sortingOrder.selected) selectedSortingOrders.push(sortingOrder);
            });
            return selectedSortingOrders;
        }

        vm.getSelectedSeatRanges = function () {
            var selectedSeatRanges = [];
            vm.seatRanges.forEach(seatRange => {
                if (seatRange.selected) selectedSeatRanges.push(seatRange);
            });
            return selectedSeatRanges;
        }

        function goToProfile() {
            $state.go('member');
        }

        function getUser() {
            return $http.get('api/private/users/')
                .then(function (response) {
                    vm.user = response.data;
                    return response.data;
                });
        }

        $scope.$on('$destroy', function () {
            $rootScope.no_scroll = false;
            $rootScope.icon_only = false;
            $rootScope.dark_text_header = false;
        });

        function close() {
            $rootScope.no_scroll = false;
            $rootScope.icon_only = false;
            $rootScope.dark_text_header = false;
            return $state.go('frontpage');
        }

        function getUnPublishedHosts() {
            return $http.get('api/list/unpublished_spaces/')
                .then(function (response) {
                    vm.spaces = response.data.data;
                    setFilteredHosts();
                });
        }


        function getEmailTypes() {
            return $http.get('api/trigger_mail_types/')
                .then(function (response) {
                    vm.triggerMails = response.data;
                });
        }

        function setFilteredHosts() {
            vm.filteredHostSubmissions = [];
            vm.filteredHostDrafts = [];
            vm.numHostSubmissions = 0;
            vm.numHostDrafts = 0;
            vm.spaces.forEach(function (space) {
                if (vm.countryFilter != 'all') {
                    if (space.space_country != vm.countryFilter) {
                        if (space.space_is_draft == 1) {
                            vm.numHostDrafts++;
                        } else {
                            vm.numHostSubmissions++;
                        }
                        return;
                    }
                }
                if (space.space_is_draft == 1) {
                    vm.numHostDrafts++;
                    vm.filteredHostDrafts.push(space);
                } else {
                    vm.numHostSubmissions++;
                    vm.filteredHostSubmissions.push(space);
                }
            });
        }

        $scope.$watch('vm.freetext', function (tmpStr) {
            vm.search();
        });

        $scope.$watch('vm.page', function (tmpStr) {
            if (vm.page == 'hosts') {
                getUnPublishedHosts();
            } else if (vm.page == 'artists') {
                getUnPublishedBands();
            } else if (vm.page == 'vouchers') {
                getVouchers();
            }

        });

        $scope.$watch('vm.pane', function (tmpStr) {
            if (vm.page == 'vouchers') {
                getVouchers();
            }
        });

        function getHosts() {
            var offset = (vm.pageNum - 1) * vm.resultsPerPage;
            var data = {
                'freetext': vm.freetext,
                'country': vm.countryFilter != 'all' ? vm.countryFilter : '',
                //'location': getSelectedLocations(),
                'spaceType': vm.getSelectedSpaceTypes(),
                'status': (vm.superhostFilter) ? [{ status: "Superhost", statusSlug: "superhost" }] : [],
                'seatRange': vm.getSelectedSeatRanges(),
                'sortingOrder': getSelectedSortingOrders(),
                'limit': vm.resultsPerPage,
                'offset': offset,
                'admin': 1
            }
            if (vm.freetext != "") {
                vm.searchString = vm.freetext;
            } else {
                vm.searchString = "";
            }
            return $http.post('api/list/spaces/', data)
                .then(function (response) {
                    vm.filteredHostsProfiles = response.data.data;
                    vm.allResultsCount = response.data.all_results_count;
                    $rootScope.$emit('update_pagination', {
                        total: vm.allResultsCount,
                        page: vm.pageNum,
                        size: vm.resultsPerPage
                    });
                })
        }


        function closeFilters() {
            vm.showLocation = false;
            vm.showMore = false;
            vm.showSort = false;
            vm.showSearch = false;
            vm.showFilterSort = false;
            vm.showGenre = false;
            vm.showTypeOfSpace = false;
            vm.showSeatRange = false;
            $rootScope.no_scroll = false;
        }


        function getUnPublishedBands() {
            return $http.get('api/list/unpublished_bands/')
                .then(function (response) {
                    vm.bands = response.data.data;
                    setFilteredArtists();
                });
        }

        function setFilteredArtists() {
            vm.filteredArtistDrafts = [];
            vm.filteredArtistSubmissions = [];
            vm.numArtistSubmissions = 0;
            vm.numArtistDrafts = 0;
            vm.bands.forEach(function (band) {
                if (vm.countryFilter != 'all') {
                    if (band.band_country != vm.countryFilter) {
                        if (band.band_is_draft == 1) {
                            vm.numArtistDrafts++;
                        } else {
                            vm.numArtistSubmissions++;
                        }
                        return;
                    }
                }
                if (band.band_is_draft == 1) {
                    vm.numArtistDrafts++;
                    vm.filteredArtistDrafts.push(band);
                } else {
                    vm.numArtistSubmissions++;
                    vm.filteredArtistSubmissions.push(band);
                }
            });
        }

        function getMusicians(favourite) {
            var offset = (vm.pageNum - 1) * vm.resultsPerPage;
            var data = {
                'genre': vm.getSelectedGenres(),
                'freetext': vm.freetext,
                'limit': vm.resultsPerPage,
                'offset': offset,
                'sortby': vm.sortBy,
                'status': (vm.allStarFilter) ? [{ status: "AllStar", statusSlug: "all_star" }] : [],
                /* 'private': vm.privateConcertView,
                'price_ranges': getSelectedBookingRanges(),
                'location_filter': vm.locationFilter, */
                'location_filter': vm.countryFilter != 'all' ? vm.countryFilter : '',
                'admin': 1
            }
            return $http.post('api/list/bands/', data)
                .then(function (response) {
                    vm.filteredArtistProfiles = response.data.data;
                    vm.allResultsCount = response.data.all_results_count;
                    $rootScope.$emit('update_pagination', {
                        total: vm.allResultsCount,
                        page: vm.pageNum,
                        size: vm.resultsPerPage
                    });
                });
        }

        function getVouchers() {
            if(vm.isPage('vouchers') && vm.isPane('bookings')) {
                vm.create_voucher = {};
                vm.create_voucher.fee_voucher_amount = 20;
            }
            return $http.get('api/fee_vouchers/' + vm.pane + "/")
                .then(function (response) {
                    vm.vouchers = response.data;
                })
        }

        function createVoucher(){
            var data = {
                fee_voucher_name : vm.create_voucher.fee_voucher_name.toUpperCase(),
                fee_voucher_amount : vm.create_voucher.fee_voucher_amount,
                fee_voucher_start_date : vm.create_voucher.fee_voucher_start_date,
                fee_voucher_end_date : vm.create_voucher.fee_voucher_end_date,
                fee_voucher_note : vm.create_voucher.fee_voucher_note,
                fee_voucher_type : vm.pane
            };
            if(vm.create_voucher.fee_voucher_discount) {
                data.fee_voucher_discount = vm.create_voucher.fee_voucher_discount;
            }
            return $http.post('api/fee_vouchers', data)
                .then(function (response) {
                    alert("Voucher " + response.data.fee_voucher_name + " successfully created");
                    getVouchers();
                    vm.createVoucherForm.$setPristine();
                    vm.create_voucher.fee_voucher_name = null;
                    vm.create_voucher.fee_voucher_amount = null;
                    vm.create_voucher.fee_voucher_start_date = null;
                    vm.create_voucher.fee_voucher_end_date = null;
                    vm.create_voucher.fee_voucher_note = null;
                });
        }

        function updateVoucher(voucher){
            var data = {
                fee_voucher_id : voucher.fee_voucher_id,
                fee_voucher_name : voucher.fee_voucher_name.toUpperCase(),
                fee_voucher_amount : voucher.fee_voucher_amount,
                fee_voucher_start_date : voucher.fee_voucher_start_date,
                fee_voucher_end_date : voucher.fee_voucher_end_date,
                fee_voucher_note : voucher.fee_voucher_note
            };
            if(voucher.fee_voucher_discount) {
                data.fee_voucher_discount = voucher.fee_voucher_discount;
            }
            return $http.patch('api/fee_vouchers', data)
                .then(function (response) {
                    getVouchers();
                });
        }

        function archiveVoucher(voucher_id){
            return $http.patch('api/fee_vouchers/' + voucher_id + '/archive')
                .then(function (response) {
                    getVouchers();
                });
        }

        function countVoucherConcerts(voucher) {
            if(voucher.concerts){
                return voucher.concerts ? voucher.concerts.length : 0;
            } else {
                return 0;
            }
        }

        function showVoucherConcerts(voucher){
            vm.selected_voucher = voucher;
            vm.show_voucher_concerts = true;
        }

        function hideVoucherConcerts(){
            vm.show_voucher_concerts = false;
        }

        function save(stop_routing_to_new_instance, $event) {
            if (vm.spaceForm.Name.$invalid || !vm.space.space_type) {
                console.warn("Cannot save when name and space type is not specified");
                return false;
            }

            vm.save_progress = 'saving';

            var data = {
                space_name: vm.space.space_name,
                space_type: vm.space.space_type,
                space_public: vm.space.space_public,
                space_published: vm.space.space_published,
                space_title: vm.space.space_title,
                space_description_short: vm.space.space_description_short,
                space_description_long: vm.space.space_description_long,
                space_address: vm.space.space_address,
                space_zip: vm.space.space_zip,
                space_city: vm.space.space_city,
                space_country: vm.space.space_country,
                space_seat_no: vm.space.space_seat_no,
                space_link: vm.space.space_link,
                space_charges_for_booking: vm.space.space_charges_for_booking,
                space_booking_cost: vm.space.space_booking_cost,
                space_facebook: vm.space.space_facebook,
                space_youtube: vm.space.space_youtube,
                space_other_social_media_links: vm.space.space_other_social_media_links,
                feels: vm.space.selected_feels,
                upload_image_slug: vm.upload_image_slug
            };

            if (!vm.slug) {
                $http.post('api/spaces/', data)
                    .then(function (response) {
                        if (!stop_routing_to_new_instance && response.data !== undefined && response.data.space_slug !== undefined) {
                            $state.go('edit_space', { space_slug: response.data.space_slug })
                            vm.save_progress = 'success';
                        } else if (response.data === 'Space with name already exists') {
                            alert('A space with the name ' + vm.space.space_name + ' already exists. Please pick a different name and try again.');
                        }
                    });
            } else {
                $http.patch('api/spaces/' + vm.slug + '/', data)
                    .then(function (response) {
                        vm.save_progress = 'success';
                    });
            }
        }
    }
})();
